<div class="layout-topbar">
  <div class="layout-topbar-start title-max-width">
    <a #menuButton class="layout-topbar-logo cursor-pointer icon-drag" (click)="onMenuButtonClick()"> </a>
    <div class="layout-topbar-title text-overflow hidden sm:block">
      {{ 'MENU.' + (layoutService.topbarMenuTitle$ | async) | translate }}
    </div>
    <app-tier-tag></app-tier-tag>
  </div>

  <div class="layout-topbar-end justify-content-end md:justify-content-between lg:justify-content-end">
    <div class="layout-topbar-actions-start lg:justify-content-end">
      <div class="align-items-center pr-4 flex">
        <em class="icon-store pr-2"></em>
        <div class="store-dropdown relative">
          <div
            class="cursor-pointer flex align-items-center"
            [ngClass]="{ 'pointer-events-none': (managedStoreList$ | async)?.content.length === 1 }"
            pStyleClass="@next"
            [hideOnOutsideClick]="true"
            pRipple
            (click)="changeStore()"
          >
            <div class="text-overflow pr-2 text-max-width">
              {{ (currentStore$ | async)?.storeCode + '-' + (currentStore$ | async)?.receiptBranchName }}
            </div>
            @if ((managedStoreList$ | async)?.content.length > 1) {
              <img width="16" height="16" src="/assets/layout/images/dropdown-down.svg" alt="Dropdown arrow" />
            }
          </div>
          <!-- <div class="ng-hidden absolute change-store-dropdown">
            <ul class="list-none p-0 m-0 bg-white border-round shadow-3">
              <li
                class="px-3 py-2 cursor-pointer flex align-items-center hover:surface-hover transition-duration-150 transition-all"
                pRipple
                (click)="changeStore()"
              >
                <em class="icon-store mr-2"></em>
                <span>เปลี่ยนร้านค้า</span>
              </li>
            </ul>
          </div> -->
        </div>
        <div class="border-right-1 h-full ml-3"></div>
      </div>
      <div class="flex align-items-center">
        <em class="icon-usermng md:mr-2 md:mr-0"></em>
        <span class="text-overflow pr-2 hidden sm:block text-max-width">{{
          (userInfo$ | async)?.localFirstName + ' ' + (userInfo$ | async)?.localLastName
        }}</span>
        <ul class="layout-topbar-items">
          <li class="flex">
            <img
              pStyleClass="@next"
              enterFromClass="ng-hidden"
              enterActiveClass="px-scalein"
              leaveToClass="ng-hidden"
              leaveActiveClass="px-fadeout"
              [hideOnOutsideClick]="true"
              pRipple
              class="cursor-pointer"
              width="16"
              height="16"
              src="/assets/layout/images/dropdown-down.svg"
              alt="Data not found"
              id="btn-info-menu"
              data-id="btn-info-menu"
              (click)="hideSideMenu()"
            />
            <div class="ng-hidden">
              <ul class="list-none p-0 m-0">
                <li class="px-3 pt-2 pb-0 block secondary-color sm:hidden">
                  {{ (currentStore$ | async)?.storeCode + '-' + (currentStore$ | async)?.receiptBranchName }}
                </li>
                <li class="px-3 pt-2 pb-0 block sm:hidden">
                  {{ (userInfo$ | async)?.localFirstName + ' ' + (userInfo$ | async)?.localLastName }}
                </li>
                <li class="px-3 py-2">รหัสผู้ใช้งาน: {{ (userInfo$ | async)?.userNo }}</li>
                <li
                  (click)="logout()"
                  class="px-3 py-2 topbar-items cursor-pointer flex align-items-center hover:surface-hover transition-duration-150 transition-all"
                >
                  <a pRipple class="flex align-items-center" id="btn-logout" data-id="btn-logout">
                    <img
                      class="mr-1"
                      width="16"
                      height="16"
                      src="/assets/layout/images/logout.svg"
                      alt="Data not found"
                    />
                    <span> {{ 'COMMON.LOGOUT' | translate }}</span>
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="layout-topbar-actions-end hidden sm:flex">
      <img width="32" height="32" src="/assets/layout/images/logo-cjx.svg" alt="Data not found" />
    </div>
  </div>
</div>

<p-drawer [(visible)]="storeSidebarVisible" [closeOnEscape]="false" [dismissible]="false" position="right">
  <ng-template pTemplate="headless">
    <div class="px-3 pt-3 pb-3 pl-4 header change-store-header flex justify-content-between">
      <a (click)="onHideStoreSidebar()" class="cursor-pointer flex align-items-center">
        <img alt="close-icon.svg" src="assets/images/close-icon.svg" />
      </a>
      <h5 class="m-0">เปลี่ยนร้านค้า</h5>
      <span style="width: 20px">&nbsp;</span>
    </div>

    <div class="content change-store-content">
      <div class="p-3" [formGroup]="searchForm">
        <span class="p-input-icon-right search-box w-full">
          <i class="pi pi-search"></i>
          <input
            formControlName="searchCriteria"
            class="w-full store-search"
            type="text"
            maxlength="50"
            pInputText
            placeholder="ระบุชื่อร้านค้า"
          />
          <em
            class="icon-close-mini cursor-pointer"
            data-id="clearSearchCriteria"
            [ngClass]="{ hidden: !searchForm.controls['searchCriteria'].value }"
            (click)="clearSearchText()"
          >
          </em>
        </span>
      </div>
      <div class="content-scroll">
        <div>
          <div
            *ngFor="let store of filteredStoreList; let i = index"
            class="store-item p-2 pl-4 pr-4 cursor-pointer hover:surface-hover"
            [ngClass]="{ 'selected-store': selectedStore?.storeNo === store.storeNo }"
            (click)="selectStore(store)"
          >
            <div class="flex flex-column">
              <div class="font-medium text-lg text-overflow">{{ store.storeCode }}-{{ store.name }}</div>
            </div>
          </div>
          <div
            *ngIf="filteredStoreList.length === 0"
            class="search-not-found p-4 text-center text-500 flex flex-column h-full align-items-center justify-content-center"
          >
            <img src="../../assets/images/search-not-found.svg" alt="Not Found Store" />
          </div>
          <ng-content></ng-content>
        </div>
      </div>
    </div>

    <div class="footer w-full">
      <p-button
        (click)="onClickSubmitSelectStore()"
        data-id="submitChangeStore"
        id="btn-submit-change-store"
        severity="secondary"
        styleClass="login-btn w-full"
        type="submit"
        [disabled]="!isSelectedStore"
      >
        ตกลง
      </p-button>
    </div>
  </ng-template>
</p-drawer>
